var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollBoxRef",class:_vm.$style['scroll-box'],attrs:{"data-lenis-prevent":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }